import { NotificationInfoIcon } from '@american-autonomy/rantizo-ui';

import BaseNotification from 'components/BaseNotification';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ErrorNotification: FunctionComponent<Props> = ({ onClose, testId = TEST_ID, text }) => (
    <BaseNotification
        className={styles.errorNotification}
        onClose={onClose}
        testId={testId}
        text={text}
    >
        <NotificationInfoIcon />
    </BaseNotification>
);

export default ErrorNotification;
